import { render, staticRenderFns } from "./CCS-SAFAtrialFibrillationScore.vue?vue&type=template&id=72fdd50a&scoped=true&"
import script from "./CCS-SAFAtrialFibrillationScore.vue?vue&type=script&lang=js&"
export * from "./CCS-SAFAtrialFibrillationScore.vue?vue&type=script&lang=js&"
import style0 from "./CCS-SAFAtrialFibrillationScore.vue?vue&type=style&index=0&id=72fdd50a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdd50a",
  null
  
)

export default component.exports